module.exports = __webpack_public_path__ + "static/boarding-notification-85367e707ea02a9e7929ce759919b663.jpg";